import { ColorPaletteProp, SvgIconProps } from '@mui/joy';
import getIcon from 'utils/getIcon';

export default function FancyIcon({name, fontSize=undefined, color,...props}: { name: string, fontSize?:  string  | undefined, color?: ColorPaletteProp} & SvgIconProps) {
    const Icon = getIcon(name);
    // console.log(props);
    return <Icon fontSize={fontSize}  {...props} />;
}
